import {
    BarChart,
    CheckSquare,
    Database,
    Rocket,
    Settings,
    Users,
    PieChart,
    Folder,
    Creatives,
} from '../../assets/sidebar-icons';
export const DRAWER_WIDTH = 240;
export const COMPACT_DRAWER_WIDTH = 65;
export const ALLOWED_COMPANIES_MENU_ITEMS = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
];
export const MENU_ITEMS = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
];
export const ADMIN_MENU_ITEMS = [
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },
    {
        id: 5,
        value: 'Data Sources',
        icon: <Database />,
        outlinedIcon: <Database color="#AD509E" />,
    },
    {
        id: 6,
        value: 'Affinity Hub',
        icon: <PieChart />,
        outlinedIcon: <PieChart color="#AD509E" />,
    },
];
export const SECOND_MENU = [
    {
        id: 7,
        value: 'Settings',
        icon: <Settings />,
        outlinedIcon: <Settings color="#AD509E" />,
    },
    {
        id: 8,
        value: 'Files',
        icon: <Folder />,
        outlinedIcon: <Folder color="#AD509E" />,
    },
];
export const CREATIVE_MENU = [
    {
        id: 9,
        value: 'Creatives',
        icon: <Creatives />,
        outlinedIcon: <Creatives color="#AD509E" />,
    },
];
export const replimuneMenu = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },
];

export const replimuneMenuOnlyPhysicians = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },
];
export const BAVENCIO_MENU_ITEMS = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },
    {
        id: 5,
        value: 'Data Sources',
        icon: <Database />,
        outlinedIcon: <Database color="#AD509E" />,
    },
];
export const ALL_MENU_ITEMS = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },
    {
        id: 5,
        value: 'Data Sources',
        icon: <Database />,
        outlinedIcon: <Database color="#AD509E" />,
    },
    {
        id: 6,
        value: 'Affinity Hub',
        icon: <PieChart />,
        outlinedIcon: <PieChart color="#AD509E" />,
    },
];

export const BAVENCIO_MENU_ITEMS_TWO = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
    {
        id: 4,
        value: 'Physicians',
        icon: <Users />,
        outlinedIcon: <Users color="#AD509E" />,
    },

    {
        id: 6,
        value: 'Affinity Hub',
        icon: <PieChart />,
        outlinedIcon: <PieChart color="#AD509E" />,
    },
];
export const CompanyUserBasedTabs = [
    {
        company: 16,
        user: 'bharat.ramachandran@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 16,
        user: 'josh.reed@emdserono.com',
        tabs: BAVENCIO_MENU_ITEMS_TWO,
        tabIds: [1, 2, 3, 5, 6],
    },
    {
        company: 16,
        user: 'dasarishruthi95@gmail.com',
        tabs: BAVENCIO_MENU_ITEMS_TWO,
        tabIds: [1, 2, 3, 5, 6],
    },
    {
        company: 3,
        user: 'bharat.ramachandran@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 16,
        user: 'rachel.hansard@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 3,
        user: 'rachel.hansard@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 37,
        user: 'rachel.hansard@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 41,
        user: 'rashella.roznitsky@regeneron.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5, 6],
    },
    {
        company: 41,
        user: 'timothy.smith2@regeneron.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5, 6],
    },
    {
        company: 16,
        user: 'heather.fregin@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 37,
        user: 'heather.fregin@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 37,
        user: 'ariane.dumas@emdserono.com',
        tabs: ALL_MENU_ITEMS,
        tabIds: [1, 2, 3, 4, 5],
    },
    {
        company: 61,
        user: 'pedro.eitzferrer@replimune.com',
        tabs: MENU_ITEMS,
        tabIds: [1, 2, 3],
    },
    {
        company: 66,
        user: 'pedro.eitzferrer@replimune.com',
        tabs: replimuneMenu,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 64,
        user: 'pedro.eitzferrer@replimune.com',
        tabs: replimuneMenu,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 161,
        user: 'anweshweighs65@gmail.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 165,
        user: 'anweshweighs65@gmail.com',
        tabs: MENU_ITEMS,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 66,
        user: 'anweshweighs65@gmail.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 61,
        user: 'vipin@pharmaforceiq.com',
        tabs: MENU_ITEMS,
        tabIds: [1, 2, 3],
    },
    {
        company: 66,
        user: 'vipin@pharmaforceiq.com',
        tabs: replimuneMenu,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 64,
        user: 'vipin@pharmaforceiq.com',
        tabs: replimuneMenu,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 66,
        user: 'Michael.Wilinsky@replimune.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 66,
        user: 'linda.shepherd@replimune.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 66,
        user: 'rick.maffei@replimune.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 66,
        user: 'veronica.cook@replimune.com',
        tabs: replimuneMenuOnlyPhysicians,
        tabIds: [1, 4],
    },
    {
        company: 66,
        user: 'sarah.donner@replimune.com',
        tabs: replimuneMenu,
        tabIds: [1, 2, 3, 4],
    },
    {
        company: 99,
        user: 'kelly.lively@emdserono.com',
        tabs: MENU_ITEMS,
        tabIds: [1, 2, 3],
    },
];
export const OminiChannelMenu = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 5,
        value: 'Data Sources',
        icon: <Database />,
        outlinedIcon: <Database color="#AD509E" />,
    },
    {
        id: 6,
        value: 'Affinity Hub',
        icon: <PieChart />,
        outlinedIcon: <PieChart color="#AD509E" />,
    },
];
export const OminiChannelAdminMenu = [
    {
        id: 1,
        value: 'Dashboard',
        icon: <BarChart />,
        outlinedIcon: <BarChart color="#AD509E" />,
    },
    {
        id: 2,
        value: 'Campaigns',
        icon: <Rocket />,
        outlinedIcon: <Rocket color="#AD509E" />,
    },
    {
        id: 3,
        value: 'Queries',
        icon: <CheckSquare />,
        outlinedIcon: <CheckSquare color="#AD509E" />,
    },
    {
        id: 5,
        value: 'Data Sources',
        icon: <Database />,
        outlinedIcon: <Database color="#AD509E" />,
    },
    {
        id: 6,
        value: 'Affinity Hub',
        icon: <PieChart />,
        outlinedIcon: <PieChart color="#AD509E" />,
    },
];
